import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { InteractionStatus } from '../../../../models/interactions.model';
import { MapFromPipe } from '../../../../pipes/map-from.pipe';
import { FlowSubflowHeader } from '../../interaction-flow.model';

@Component({
  selector: 'app-flow-subflow-header',
  imports: [NgClass, MapFromPipe],
  templateUrl: './flow-subflow-header.component.html',
  styleUrl: './flow-subflow-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlowSubflowHeaderComponent {
  readonly data = input.required<FlowSubflowHeader>();

  protected readonly statusMapping: Record<InteractionStatus, string> = {
    published: 'Gepubliceerd',
    draft: 'Concept',
  };
}
